export default Object.freeze({
  pending: 1,
  approved: 2,
  denegate: 3,
  review: 5,
  no_payment: 6,
  payment: 7,
});
